import React, { useState, useRef, useEffect } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import OutlinedInput from "@mui/material/OutlinedInput";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import Chip from "@mui/material/Chip";
import dayjs from "dayjs";
import { useFile } from "@redux/files";
import { useAdvertisement } from "@redux/advertisement";
import AdvertiserSelect from "./AdvertiserSelect";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import images from "@app/images";
import { DefaultItem } from "@assets/papers";
import { ImgFileInput } from "@assets/inputs";
import { useInput, useInputNoVal } from "@assets/hooks";
import { maxLength } from "@assets/validators";
import {
  OutlinedInputDefault,
  OutlinedInputRightAdornment,
} from "@assets/TextField";
import { DefaultLabel } from "@assets/label";
import { DefaultGroups } from "@assets/radios";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { GreyLightButton } from "@assets/buttons";
import { useMenuDispatch } from "@assets/contexts/MenuContext";
import { etcMap } from "@assets/utils/check";
import { Checkbox, FormControl, MenuItem, Select } from "@mui/material";
import {
  AdFilter,
  AdUser,
  OpenType,
  BannerBaseData,
  OpenTypeLeft,
  SymptomList,
  DiseaseList,
} from "./adTypeList";
import UrlInputByOpenType from "./UrlInputByOpenType";

const TitleMaxLength = 20;

const CompAdAdd = () => {
  const newData = { ...BannerBaseData };
  const value = useMenuDispatch(); // function  context
  const advertisement = useAdvertisement();
  const title = useInput("", (value) => value.length <= TitleMaxLength); // 광고명
  const adGoods = useInputNoVal("1"); // 광고명
  const adType = useInputNoVal("1"); // 광고유형
  const impressions = useInputNoVal(10000); // 노출수
  const selectAd = useInputNoVal(""); // 광고주 / 대행사
  const [val, setVal] = useState({
    view_date_start: dayjs(new Date()).format("YYYY-MM-DD HH:mm:00"),
    view_date_end: dayjs(new Date()).format("YYYY-MM-DD HH:mm:59"),
  }); // 시작일
  const [banner, setBanner] = useState([newData]);
  const [index, setIndex] = useState(0);
  const [adFilter, setAdFilter] = useState("");
  const [adUser, setAdUser] = useState("ALL");
  const [orderNum, setOrderNum] = useState(0);
  const [extra, setExtra] = useState({});
  const inputRef = useRef(null);
  const files = useFile();
  const adGoodsKey = String(adGoods.value);
  const isFullscreenAd = adGoodsKey === "9";

  useEffect(() => {
    setAdFilter(
      adGoodsKey in AdFilter && !isFullscreenAd
        ? AdFilter[adGoodsKey]?.[0]?.id
        : ""
    );
    setAdUser(
      adGoodsKey in AdUser
        ? AdUser[adGoodsKey]?.[0]?.id
        : "ALL"
    );
    setBanner([newData]);
    setExtra(isFullscreenAd ? { screen: AdFilter["9"]?.[0]?.id } : {});
  }, [adGoods?.value]);

  const [errorData, setErrorData] = useState({
    start: true,
    end: true,
  }); // 날짜 체크

  const handleDateChange = (newValue, cheker = "start") => {
    if (cheker === "start") {
      setVal({
        ...val,
        view_date_start: dayjs(newValue).format("YYYY-MM-DD HH:mm:00"),
      });
    } else {
      setVal({
        ...val,
        view_date_end: dayjs(newValue).format("YYYY-MM-DD HH:mm:59"),
      });
    }
  };
  // 이미지 추가
  const handleAddImage = (e) => {
    const { value } = e.target;
    const newData = (nd) => {
      let arr = banner.map((d, i) => {
        if (i === index) {
          return { ...d, img_url: nd.url };
        }
        return d;
      });
      return arr;
    };
    if (value !== "" && value) {
      files.uploadAdBanner(e.target.files[0], (data, response) => {
        if (response.status === 200) {
          if (data.error) {
            alert(data.error.message);
          } else {
            const dataListCheck =
              Array.isArray(data.list) && data.list.length > 0
                ? data.list[0]
                : data.result[0];
            setBanner(newData(dataListCheck));
          }
        } else {
          alert("에러가 발생하였습니다.");
        }
      });
    }
  };

  // 배너 추가
  const handleBannerAdd = () => {
    if (banner.length > 9) {
      alert("최대 10개까지 가능합니다.");
      return false;
    }
    const fistArr = [...banner.slice(0, index + 1)];
    const secondArr = [...banner.slice(index + 1, banner.length)];
    const newArr = [...fistArr, newData, ...secondArr];
    setBanner(newArr);
    setIndex(index + 1);
  };

  // 이미지 삭제
  const handleDelete = (e) => {
    const filterData = banner.filter((data, i) => {
      return i !== index;
    });
    if (filterData.length === 0) {
      setIndex(0);
      setBanner([newData]);
    } else {
      if (index !== 0) {
        setIndex(index - 1);
      }
      setBanner(filterData);
    }
  };
  // 배너 포커스 변경
  const handleBannerTargetChange = (typeCase = "prev") => {
    setIndex(typeCase === "prev" ? index - 1 : index + 1);
  };

  const handleTextUpdate = (e, mobile = "ios") => {
    const bannerNew = banner.map((data, i) => {
      if (index === i) {
        if (mobile === "ios") {
          data.link_url_i = e.target.value;
        } else if (mobile === "name") {
          data.img_name = e.target.value;
        } else if (mobile === "opentype") {
          data.open_type = e.target.value;
        } else {
          data.link_url = e.target.value;
        }
      }
      return data;
    });
    setBanner(bannerNew);
  };

  // 생성
  const handleComplete = () => {
    if (selectAd.value === "") {
      alert("광고주/대행사 를 선택해주세요.");
      return false;
    }
    if (!title.value || title.value === "") {
      alert("캠페인명을 입력해 주세요.");
      return false;
    } else {
      if (adType.value === "2" || adType.value === 2) {
        if (impressions.value === "0" || impressions.value === "") {
          alert("노출수를 확인해주세요");
          return false;
        }
      }
      if (isFullscreenAd && !extra?.screen) {
        alert("대상 스크린을 선택해주세요.");
        return false;
      }

      const bannerDataChecker = banner.map((data) => {
        const isRewardManualOpenType = adGoods.value == 7 && data.open_type === "N";

        if (adGoods.value == 6) {
          if (data.img_name !== "" && data.img_url !== "") {
            return 0;
          } else {
            return 1;
          }
        }
        if (adGoods.value == 4 || adGoods.value == 5) {
          if (data.link_url !== "" && data.link_url_i !== "") {
            return 0;
          } else {
            return 1;
          }
        }
        if (isRewardManualOpenType) {
          if (data.img_name !== "" && data.img_url !== "") {
            return 0;
          } else {
            return 1;
          }
        }
        if (
          data.img_name !== "" &&
          data.img_url !== "" &&
          data.link_url !== "" &&
          data.link_url_i !== ""
        ) {
          return 0;
        } else {
          return 1;
        }
      });
      const result = bannerDataChecker.reduce(function add(sum, currValue) {
        return sum + currValue;
      }, 0);

      if (result > 0) {
        alert("입력하지 않은 이미지 / 이미지명 / URL 이 존재합니다.");
        return false;
      }
      const totalData = {
        advertiser_code: selectAd.value,
        ad_type: adGoods.value,
        ad_user: adUser,
        title: title.value,
        banners: banner,
        view_date_start: val.view_date_start,
        view_date_end: val.view_date_end,
        order_num: orderNum,
        cpm_limit: adType.value === "1" ? null : impressions.value,
      };
      if (adFilter && !isFullscreenAd) totalData.ad_filter = [adFilter];
      if (Object.keys(extra).length > 0) totalData.extra = extra;
      value({ type: "loadingStart" });
      advertisement.add(totalData, (data, response) => {
        if (response.status === 200) {
          if (data.error) {
            alert(data.error.message);
          } else {
            alert("생성완료 되었습니다.");
            setIndex(0);
            setBanner([newData]);
            adGoods.onReset("1");
            selectAd.onReset("");
            title.onReset("");
            setVal({
              view_date_start: dayjs(new Date()).format("YYYY-MM-DD HH:mm:00"),
              view_date_end: dayjs(new Date()).format("YYYY-MM-DD HH:mm:59"),
            });
          }
          value({ type: "loadingEnd" });
        } else {
          alert("에러가 발생하였습니다.");
          value({ type: "loadingEnd" });
        }
      });
    }
  };

  const handlepageGo = (i) => {
    setIndex(i);
  };

  // const goodsRadioData = [
  //   { index: 0, value: "1", name: "배너" },
  //   { index: 1, value: "2", name: "종료팝업" },
  // ];
  const adTypeRadioData = [
    { index: 0, value: "1", name: "CPP" },
    { index: 1, value: "2", name: "CPM" },
  ];

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={2.5}>
        <Grid item xl={6} lg={6} md={12} xs={12}>
          <DefaultItem sx={{ boxShadow: 0, height: "100%" }}>
            <Grid
              container
              direction="column"
              sx={{ pt: 8.75, pl: 7.5, pr: 7.5 }}
            >
              <Stack direction="row" spacing={1}>
                <Chip
                  label="STEP 01"
                  sx={{
                    bgcolor: "grey.900",
                    color: "white",
                    fontWeight: 500,
                    mb: 3,
                  }}
                />
              </Stack>
              <Grid
                container
                sx={{
                  mb: 3,
                }}
              >
                <Typography variant="h2" fontWeight={500} color={"grey.900"}>
                  등록할 광고 정보를 작성해 주세요.
                </Typography>
              </Grid>
              <Grid container>
                <Grid container sx={{ mb: adGoods?.value == 7 || adGoods?.value == 8 || adGoods?.value == 13 || adGoods?.value == 14 || adGoods?.value == 15 ? 0 : 3 }}>
                  <Grid sx={{ width: "50%", pr: 1.25 }}>
                    <Box sx={{ mb: 2, width: "100%" }}>
                      <DefaultLabel name="광고주/대행사" />
                      <AdvertiserSelect
                        selectAd={selectAd.value}
                        onAdver={selectAd.onChange}
                      />
                    </Box>
                  </Grid>
                  <Grid sx={{ width: "50%", pl: 1.25 }}>
                    <Box sx={{ mb: 2, width: "100%" }}>
                      <DefaultLabel
                        name={adGoods?.value == 7 || adGoods?.value == 8 || adGoods?.value == 13 || adGoods?.value == 14 || adGoods?.value == 15 ? "광고상품" : "캠페인명"}
                      />
                      <OutlinedInputRightAdornment
                        value={title.value}
                        onChange={title.onChange}
                        name="ad_name"
                        adorment={`${title.value.length || 0} / ${TitleMaxLength}자`}
                      />
                    </Box>
                  </Grid>
                </Grid>
                {adGoods?.value == 7 || adGoods?.value == 8 || adGoods?.value == 13 || adGoods?.value == 14 || adGoods?.value == 15 ? (
                  <>
                    <Grid container sx={{ mb: 0 }}>
                      <Grid sx={{ width: "100%" }}>
                        <Box sx={{ mb: 2, width: "100%" }}>
                          <DefaultLabel name={"설명"} />
                          <OutlinedInputRightAdornment
                            value={extra?.desc || ""}
                            onChange={(e) =>
                              setExtra({ ...extra, desc: e.target.value?.length > 20 ? e.target.value.substring(0, 20) : e.target.value })
                            }
                            name="ad_desc"
                            adorment={`${extra?.desc?.length || 0} / 20자`}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                    {adGoods?.value == 13 || adGoods?.value == 14 ? (
                      <Grid container sx={{ mb: 0 }}>
                        <Grid sx={{ width: "100%" }}>
                          <Box sx={{ mb: 2, width: "100%" }}>
                            <DefaultLabel name={"필수기재 문구 (보험 등)"} />
                            <OutlinedInputDefault
                              value={extra?.caption || ""}
                              onChange={(e) => setExtra({ ...extra, caption: e.target.value })}
                              name="ad_caption"
                              krName={"필수기재 문구"}
                              multiline
                              minRows={2}
                            />
                            <Typography variant="caption" color="#9A9A9B" sx={{ mt: 0.5, display: "block" }}>
                              광고심의제한 문구. 엔터로 줄바꿈됨.
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    ) : null}
                    {adGoods?.value == 8 || adGoods?.value == 13 || adGoods?.value == 14 || adGoods?.value == 15 ? (
                      <Grid container sx={{ mb: 0 }}>
                        <Grid sx={{ width: "100%" }}>
                          <Box sx={{ mb: 2, width: "100%" }}>
                            <DefaultLabel name="GA 이벤트 이름" />
                            <OutlinedInputRightAdornment
                              value={extra?.fb_event_click || ""}
                              onChange={(e) => {
                                if (e.target.value.length > 40) {
                                } else {
                                  setExtra({
                                    ...extra,
                                    fb_event_click: e.target.value,
                                  });
                                }
                              }}
                              name="fb_event_click"
                              adorment={` ${
                                extra?.fb_event_click
                                  ? extra?.fb_event_click.length
                                  : 0
                              }/ 40자`}
                            />
                          </Box>
                        </Grid>
                      </Grid>
                    ) : null}
                    {
                      adGoods?.value == 7 ? (
                        <Grid container sx={{ mb: 3 }}>
                          <Grid sx={{ width: "50%", pr: 1.25 }}>
                            <Box sx={{ mb: 2, width: "100%" }}>
                              <DefaultLabel name={"포인트"} />
                              <OutlinedInputDefault
                                inputType="number"
                                value={extra?.point || 0}
                                onChange={(e) =>
                                  setExtra({
                                    ...extra,
                                    point: Number(e.target.value),
                                  })
                                }
                                name="ad_point"
                              />
                            </Box>
                          </Grid>
                          <Grid sx={{ width: "50%", pl: 1.25 }}>
                            <Box sx={{ mb: 2, width: "100%" }}>
                              <DefaultLabel name={"우선순위"} />
                              <OutlinedInputDefault
                                inputType="number"
                                value={orderNum}
                                onChange={(e) =>
                                  setOrderNum(Number(e.target.value))
                                }
                                name="ad_order_num"
                              />
                            </Box>
                          </Grid>
                        </Grid>  
                      ) : null
                    }
                  </>
                ) : null}
                <Grid container sx={{ mb: 3 }}>
                  <Grid sx={{ width: "50%" }}>
                    <Box sx={{ mb: 2, width: "100%", pr: 1.25 }}>
                      <DefaultLabel name="시작일" />
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DateTimePicker
                          inputFormat={"yyyy-MM-dd HH:mm:ss"}
                          mask={"____-__-__"}
                          disableOpenPicker
                          value={val.view_date_start}
                          autoFocus
                          margin="dense"
                          onChange={(e) => handleDateChange(e, "start")}
                          onError={(_, error) => {
                            setErrorData({
                              ...errorData,
                              start: dayjs(error).isValid(),
                            });
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              sx={{
                                "& .MuiInputBase-root": {
                                  height: 41,
                                  m: 0,
                                  fontSize: 12,
                                  "& .MuiButtonBase-root": {},
                                  "& .MuiInputBase-input": {
                                    padingRight: 1,
                                  },
                                },
                              }}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Box>
                  </Grid>
                  <Grid sx={{ width: "50%" }}>
                    <Box sx={{ mb: 2, width: "100%", pl: 1.25 }}>
                      <DefaultLabel name="종료일" />
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DateTimePicker
                          inputFormat={"yyyy-MM-dd HH:mm:ss"}
                          mask={"____-__-__"}
                          disableOpenPicker
                          value={val.view_date_end}
                          autoFocus
                          margin="dense"
                          onChange={(e) => handleDateChange(e, "end")}
                          onError={(_, error) => {
                            setErrorData({
                              ...errorData,
                              end: dayjs(error).isValid(),
                            });
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              sx={{
                                "& .MuiInputBase-root": {
                                  height: 41,
                                  m: 0,
                                  fontSize: 12,
                                  "& .MuiButtonBase-root": {},
                                  "& .MuiInputBase-input": {
                                    padingRight: 1,
                                  },
                                },
                              }}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Box>
                  </Grid>
                </Grid>
                <Grid container sx={{ mb: 3 }}>
                  <Grid sx={{ flexGrow: 1 }}>
                    <Box sx={{ mb: 2, width: "100%" }}>
                      <DefaultLabel name="광고 상품" />
                      <DefaultGroups
                        name="ad-goods"
                        onChange={adGoods.onChange}
                        value={adGoods.value}
                        rCase="row"
                        list={etcMap}
                      />
                    </Box>
                  </Grid>
                </Grid>
                {(adGoods.value == 7 || adGoods.value == 8) &&
                OpenTypeLeft[String(adGoods.value)]?.length > 0 ? (
                  <Grid sx={{ flexGrow: 1 }}>
                    <Box sx={{ flex: "100%" }}>
                      <DefaultLabel name="오픈 방식" />
                      <FormControl fullWidth>
                        <Select
                          labelId="open_type"
                          id="open_type"
                          align="left"
                          size="small"
                          sx={{ height: 41 }}
                          value={banner[index].open_type}
                          onChange={(e) => {
                            const openType = e.target.value;
                            if (adGoods.value == 7 || adGoods.value == 8) {
                              const bannerNew = banner.map((data, i) => {
                                if (index === i) {
                                  data.open_type = openType;
                                  data.link_url = "";
                                  data.link_url_i = "";
                                }
                                return data;
                              });
                              setBanner(bannerNew);
                              if (adGoods.value == 7) {
                                setExtra({
                                  ...(extra || {}),
                                  position: {
                                    ...(extra?.position || {}),
                                    fever_tab: {
                                      ...(extra?.position?.fever_tab || {}),
                                      url: "",
                                      url_i: "",
                                    },
                                  },
                                });
                              }
                            } else {
                              handleTextUpdate(e, "opentype");
                            }
                          }}
                        >
                          {OpenTypeLeft[String(adGoods.value)]?.map(
                            (data, index) => (
                              <MenuItem value={data.id} key={data.id}>
                                <Typography
                                  variant="body"
                                  color="grey.900"
                                  fontWeight={400}
                                >
                                  {data.text}
                                </Typography>
                              </MenuItem>
                            )
                          )}
                        </Select>
                      </FormControl>
                    </Box>
                  </Grid>
                ) : (
                  <Grid container sx={{ mb: 3 }}>
                    <Grid sx={{ flexGrow: 1 }}>
                      <Box sx={{ mb: 2, width: "100%" }}>
                        <DefaultLabel name="광고 유형" />
                        <DefaultGroups
                          name="ad-type"
                          {...adType}
                          rCase="row"
                          list={adTypeRadioData}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                )}
                <Grid
                  container
                  sx={{ mb: 3, display: adType.value === "1" && "none" }}
                >
                  <Box sx={{ mb: 2, width: "100%" }}>
                    <DefaultLabel name="노출수" />
                    <OutlinedInput
                      id="outlined-adornment-ad-impressions"
                      value={impressions.value}
                      type="number"
                      onChange={impressions.onChange}
                      sx={{ height: 41, m: 0, fontSize: 12 }}
                      fullWidth
                      inputProps={{
                        "aria-label": "노출수",
                      }}
                    />
                  </Box>
                </Grid>
                <Grid container sx={{ mb: 3 }}>
                  {AdUser[String(adGoods.value)]?.length > 0 ? (
                    <Grid sx={{ flexGrow: 1, pr: 1.25 }}>
                      <Box sx={{ flex: "100%" }}>
                        <DefaultLabel name="노출대상" />
                        <FormControl fullWidth>
                          <Select
                            labelId="ad_user"
                            id="ad_user"
                            align="left"
                            size="small"
                            sx={{ height: 41 }}
                            value={adUser}
                            onChange={(e) => {
                              setAdUser(e.target.value);
                            }}
                          >
                            {AdUser[String(adGoods.value)]?.map(
                              (data, index) => (
                                <MenuItem value={data.id} key={data.id}>
                                  <Typography
                                    variant="body"
                                    color="grey.900"
                                    fontWeight={400}
                                  >
                                    {data.text}
                                  </Typography>
                                </MenuItem>
                              )
                            )}
                          </Select>
                        </FormControl>
                      </Box>
                    </Grid>
                  ) : null}
                  {AdFilter[String(adGoods.value)]?.length > 0 && !isFullscreenAd ? (
                    <Grid
                      key={String(adGoods.value)}
                      sx={{ flexGrow: 1, pl: 1.25 }}
                    >
                      <Box sx={{ width: "100%" }}>
                        <DefaultLabel name="대상 스크린" />
                        <FormControl fullWidth>
                          <Select
                            labelId="ad_filter"
                            id="ad_filter"
                            align="left"
                            size="small"
                            sx={{ height: 41 }}
                            value={adFilter}
                            onChange={(e) => {
                              setAdFilter(e.target.value);
                            }}
                          >
                            {AdFilter[String(adGoods.value)]?.map(
                              (data, index) => (
                                <MenuItem value={data.id} key={data.id}>
                                  <Typography
                                    variant="body"
                                    color="grey.900"
                                    fontWeight={400}
                                  >
                                    {data.text}
                                  </Typography>
                                </MenuItem>
                              )
                            )}
                          </Select>
                        </FormControl>
                      </Box>
                    </Grid>
                  ) : null}
                </Grid>
              </Grid>
            </Grid>
          </DefaultItem>
        </Grid>
        <Grid item xl={6} lg={6} md={12} xs={12}>
          <DefaultItem sx={{ boxShadow: 0 }}>
            <Grid
              container
              direction="column"
              sx={{ pt: 8.75, pl: 7.5, pr: 7.5 }}
            >
              <Stack direction="row" spacing={1}>
                <Chip
                  label="STEP 02"
                  sx={{
                    bgcolor: "grey.900",
                    color: "white",
                    fontWeight: 500,
                    mb: 3,
                  }}
                />
              </Stack>
              <Grid
                container
                sx={{
                  mb: 3,
                }}
              >
                <Typography variant="h2" fontWeight={500} color={"grey.900"}>
                  {adGoods?.value == 6
                    ? "이미지를 입력해 주세요."
                    : adGoods?.value == 4 || adGoods?.value == 5
                    ? "관련 정보와 링크를 입력해 주세요."
                    : "이미지와 관련 링크를 입력해 주세요."}
                </Typography>
              </Grid>
              {adGoods?.value == 4 ? (
                <>
                  <Grid container sx={{ mb: 3 }}>
                    <Box sx={{ mb: 2, width: "100%" }}>
                      <DefaultLabel name="메세지" />
                      <OutlinedInputRightAdornment
                        value={extra?.message || ""}
                        onChange={(e) => {
                          if (e.target.value.length > 100) {
                          } else {
                            setExtra({ ...extra, message: e.target.value });
                          }
                        }}
                        name="message"
                        adorment={` ${
                          extra?.message ? extra?.message.length : 0
                        }/ 100자`}
                      />
                    </Box>
                    <Box sx={{ mb: 2, width: "100%" }}>
                      <DefaultLabel name="버튼 텍스트" />
                      <OutlinedInputRightAdornment
                        value={extra?.button_text || ""}
                        onChange={(e) => {
                          if (e.target.value.length > 20) {
                          } else {
                            setExtra({ ...extra, button_text: e.target.value });
                          }
                        }}
                        name="button_text"
                        adorment={` ${
                          extra?.button_text ? extra?.button_text.length : 0
                        }/ 20자`}
                      />
                    </Box>
                    <Box sx={{ mb: 2, width: "100%" }}>
                      <DefaultLabel name="GA 이벤트 이름" />
                      <OutlinedInputRightAdornment
                        value={extra?.fb_event_click || ""}
                        onChange={(e) => {
                          if (e.target.value.length > 40) {
                          } else {
                            setExtra({
                              ...extra,
                              fb_event_click: e.target.value,
                            });
                          }
                        }}
                        name="fb_event_click"
                        adorment={` ${
                          extra?.fb_event_click
                            ? extra?.fb_event_click.length
                            : 0
                        }/ 40자`}
                      />
                    </Box>
                  </Grid>
                </>
              ) : adGoods?.value == 5 ? (
                <>
                  <Grid container sx={{ mb: 3 }}>
                    <Box sx={{ mb: 2, width: "100%" }}>
                      <DefaultLabel name="타이틀" />
                      <OutlinedInputRightAdornment
                        value={extra?.title || ""}
                        onChange={(e) => {
                          if (e.target.value.length > 20) {
                          } else {
                            setExtra({ ...extra, title: e.target.value });
                          }
                        }}
                        name="title"
                        adorment={` ${
                          extra?.title ? extra?.title.length : 0
                        }/ 20자`}
                      />
                    </Box>
                    <Box sx={{ mb: 2, width: "100%" }}>
                      <DefaultLabel name="메세지" />
                      <OutlinedInputRightAdornment
                        value={extra?.message || ""}
                        onChange={(e) => {
                          if (e.target.value.length > 100) {
                          } else {
                            setExtra({ ...extra, message: e.target.value });
                          }
                        }}
                        name="message"
                        adorment={` ${
                          extra?.message ? extra?.message.length : 0
                        }/ 100자`}
                      />
                    </Box>
                    <Box sx={{ mb: 2, width: "100%" }}>
                      <DefaultLabel name="GA 이벤트 이름" />
                      <OutlinedInputRightAdornment
                        value={extra?.fb_event_click || ""}
                        onChange={(e) => {
                          if (e.target.value.length > 40) {
                          } else {
                            setExtra({
                              ...extra,
                              fb_event_click: e.target.value,
                            });
                          }
                        }}
                        name="fb_event_click"
                        adorment={` ${
                          extra?.fb_event_click
                            ? extra?.fb_event_click.length
                            : 0
                        }/ 40자`}
                      />
                    </Box>
                  </Grid>
                </>
              ) : adGoods?.value == 7 || adGoods.value == 8 || adGoods.value == 13 || adGoods.value == 14 || adGoods.value == 15 ? (
                <>
                  <Grid>
                    <Box sx={{ mb: 2, width: "127px" }}>
                      <Grid
                        container
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Grid sx={{ flexGrow: 1 }}>
                          <ImgFileInput
                            accept="image/*"
                            id="contained-button-file"
                            multiple
                            type="file"
                            ref={inputRef}
                            onChange={handleAddImage}
                          />
                          {banner[index] && banner[index].img_url ? (
                            <Grid
                              container
                              justifyContent="center"
                              alignItems="center"
                              // onMouseEnter={() => setIsShown(true)}
                              // onMouseLeave={() => setIsShown(false)}
                              sx={{
                                height: 127,
                                mt: 2,
                                mb: 2,
                                backgroundColor: "#bebebe",
                                border: "1px solid #c4c4c4",
                                backgroundImage: `url(${banner[index].img_url})`,
                                backgroundSize: "cover",
                                backgroundPosition: "50% 50%",
                                backgroundRepeat: "no-repeat",
                              }}
                            ></Grid>
                          ) : (
                            <Grid
                              container
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                height: 127,
                                mt: 2,
                                mb: 2,
                                backgroundColor: "#F6F6F8",
                                borderRadius: "5px",
                              }}
                            >
                              <label htmlFor="contained-button-file">
                                <Box sx={{ cursor: "pointer" }}>
                                  <Grid sx={{ color: "white" }}>
                                    <img
                                      src={images.inc_img_plus.default}
                                      alt="img_plus"
                                    />
                                  </Grid>
                                  <Typography
                                    variant="body2"
                                    fontWeight={500}
                                    color="#DDDDDF"
                                  >
                                    아이콘 선택
                                  </Typography>
                                </Box>
                              </label>
                            </Grid>
                          )}
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                  <Grid container sx={{ mb: 3 }}>
                    <Box sx={{ mb: 2, width: "100%" }}>
                      <DefaultLabel name="이미지명" />
                      <OutlinedInputRightAdornment
                        value={banner[index].img_name}
                        onChange={(e) => {
                          if (e.target.value.length > 100) {
                          } else {
                            handleTextUpdate(e, "name");
                          }
                        }}
                        name="banner_name"
                        adorment={` ${
                          banner[index].img_name
                            ? banner[index].img_name.length
                            : 0
                        }/ 100자`}
                      />
                    </Box>
                  </Grid>
              </>
              ) : adGoods?.value == 9 ? (
                <>
                  <Grid container sx={{ mb: 3 }}>
                    <Box sx={{ mb: 2, width: "100%" }}>
                      <Grid
                        container
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Grid sx={{ flexGrow: 1 }}>
                          <ImgFileInput
                            accept="image/*"
                            id="contained-button-file"
                            multiple
                            type="file"
                            ref={inputRef}
                            onChange={handleAddImage}
                          />
                          {banner[index] && banner[index].img_url ? (
                            <Grid
                              container
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                height: 200,
                                mt: 2,
                                mb: 2,
                                backgroundColor: "#bebebe",
                                border: "1px solid #c4c4c4",
                                backgroundImage: `url(${banner[index].img_url})`,
                                backgroundSize: "cover",
                                backgroundPosition: "50% 50%",
                                backgroundRepeat: "no-repeat",
                              }}
                            ></Grid>
                          ) : (
                            <Grid
                              container
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                height: 200,
                                mt: 2,
                                mb: 2,
                                backgroundColor: "#F6F6F8",
                                borderRadius: "5px",
                              }}
                            >
                              <label htmlFor="contained-button-file">
                                <Box sx={{ cursor: "pointer" }}>
                                  <Grid sx={{ color: "white" }}>
                                    <img
                                      src={images.inc_img_plus.default}
                                      alt="img_plus"
                                    />
                                  </Grid>
                                  <Typography
                                    variant="body2"
                                    fontWeight={500}
                                    color="#DDDDDF"
                                  >
                                    이미지 추가
                                  </Typography>
                                </Box>
                              </label>
                            </Grid>
                          )}
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                  <Grid container sx={{ mb: 3 }}>
                    <Box sx={{ mb: 2, width: "100%" }}>
                      <DefaultLabel name="이미지명" />
                      <OutlinedInputRightAdornment
                        value={banner[index].img_name}
                        onChange={(e) => {
                          if (e.target.value.length > 100) {
                          } else {
                            handleTextUpdate(e, "name");
                          }
                        }}
                        name="banner_name"
                        adorment={` ${
                          banner[index].img_name
                            ? banner[index].img_name.length
                            : 0
                        }/ 100자`}
                      />
                    </Box>
                  </Grid>
                  <Grid container sx={{ mb: 3 }}>
                    <Box sx={{ mb: 2, width: "100%" }}>
                      <DefaultLabel name="텍스트 1 (강조)" />
                      <Grid container spacing={1}>
                        <Grid item xs={9}>
                          <OutlinedInputDefault
                            value={extra?.texts?.[0]?.text || ""}
                            onChange={(e) =>
                              setExtra({
                                ...extra,
                                texts: [
                                  { text: e.target.value, color: extra?.texts?.[0]?.color || "#F46281" },
                                  extra?.texts?.[1] || { text: "", color: "#000" },
                                ],
                              })
                            }
                            name="text1"
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <OutlinedInputDefault
                            value={extra?.texts?.[0]?.color || "#F46281"}
                            onChange={(e) =>
                              setExtra({
                                ...extra,
                                texts: [
                                  { text: extra?.texts?.[0]?.text || "", color: e.target.value },
                                  extra?.texts?.[1] || { text: "", color: "#000" },
                                ],
                              })
                            }
                            name="color1"
                          />
                        </Grid>
                      </Grid>
                    </Box>
                    <Box sx={{ mb: 2, width: "100%" }}>
                      <DefaultLabel name="텍스트 2" />
                      <Grid container spacing={1}>
                        <Grid item xs={9}>
                          <OutlinedInputDefault
                            value={extra?.texts?.[1]?.text || ""}
                            onChange={(e) =>
                              setExtra({
                                ...extra,
                                texts: [
                                  extra?.texts?.[0] || { text: "", color: "#F46281" },
                                  { text: e.target.value, color: extra?.texts?.[1]?.color || "#000" },
                                ],
                              })
                            }
                            name="text2"
                            multiline
                            minRows={2}
                            maxRows={4}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <OutlinedInputDefault
                            value={extra?.texts?.[1]?.color || "#000"}
                            onChange={(e) =>
                              setExtra({
                                ...extra,
                                texts: [
                                  extra?.texts?.[0] || { text: "", color: "#F46281" },
                                  { text: extra?.texts?.[1]?.text || "", color: e.target.value },
                                ],
                              })
                            }
                            name="color2"
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                  <Grid container sx={{ mb: 3 }}>
                    <Grid item xs={6} sx={{ pr: 1 }}>
                      <DefaultLabel name="나이 (시작)" />
                      <OutlinedInputDefault
                        inputType="number"
                        value={extra?.params?.age?.[0] ?? 0}
                        onChange={(e) =>
                          setExtra({
                            ...extra,
                            params: {
                              ...extra?.params,
                              age: [Number(e.target.value), extra?.params?.age?.[1] ?? 15],
                            },
                          })
                        }
                        name="age_start"
                      />
                    </Grid>
                    <Grid item xs={6} sx={{ pl: 1 }}>
                      <DefaultLabel name="나이 (끝)" />
                      <OutlinedInputDefault
                        inputType="number"
                        value={extra?.params?.age?.[1] ?? 15}
                        onChange={(e) =>
                          setExtra({
                            ...extra,
                            params: {
                              ...extra?.params,
                              age: [extra?.params?.age?.[0] ?? 0, Number(e.target.value)],
                            },
                          })
                        }
                        name="age_end"
                      />
                    </Grid>
                  </Grid>
                  <Grid container sx={{ mb: 3 }}>
                    <Box sx={{ mb: 2, width: "100%" }}>
                      <DefaultLabel name="대상 스크린" />
                      <FormControl fullWidth>
                        <Select
                          value={extra?.screen || ""}
                          onChange={(e) =>
                            setExtra({ ...extra, screen: e.target.value })
                          }
                          size="small"
                          sx={{ height: 41 }}
                        >
                          {AdFilter[9]?.map((data) => (
                            <MenuItem key={data.id} value={data.id}>
                              <Typography variant="body2">{data.text}</Typography>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                  </Grid>
                  <Grid container sx={{ mb: 3 }}>
                    <Box sx={{ mb: 2, width: "100%" }}>
                      <DefaultLabel name="증상 조건" />
                      <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                        <Checkbox
                          checked={extra?.params?.symptom === "*"}
                          onChange={(e) => {
                            setExtra({
                              ...extra,
                              params: {
                                ...extra?.params,
                                symptom: e.target.checked ? "*" : [],
                              },
                            });
                          }}
                          size="small"
                        />
                        <Typography variant="body2" fontWeight={600}>전체 (모든 증상)</Typography>
                      </Box>
                      {extra?.params?.symptom !== "*" && (
                        <FormControl fullWidth>
                          <Select
                            multiple
                            value={Array.isArray(extra?.params?.symptom) ? extra.params.symptom : []}
                            onChange={(e) => {
                              setExtra({
                                ...extra,
                                params: {
                                  ...extra?.params,
                                  symptom: e.target.value,
                                },
                              });
                            }}
                            renderValue={(selected) => {
                              if (selected.length === 0) return "증상을 선택하세요";
                              return SymptomList
                                .filter((s) => selected.includes(s.id))
                                .map((s) => s.text)
                                .join(", ");
                            }}
                            size="small"
                            sx={{ height: 41 }}
                            MenuProps={{ PaperProps: { sx: { maxHeight: 300 } } }}
                          >
                            {SymptomList.map((symptom) => (
                              <MenuItem key={symptom.id} value={symptom.id}>
                                <Checkbox checked={Array.isArray(extra?.params?.symptom) && extra.params.symptom.includes(symptom.id)} size="small" />
                                <Typography variant="body2">{symptom.text}</Typography>
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}
                    </Box>
                  </Grid>

                  <Grid container sx={{ mb: 3 }}>
                    <Box sx={{ mb: 2, width: "100%" }}>
                      <DefaultLabel name="질병 조건" />
                      <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                        <Checkbox
                          checked={extra?.params?.diseases === "*"}
                          onChange={(e) => {
                            setExtra({
                              ...extra,
                              params: {
                                ...extra?.params,
                                diseases: e.target.checked ? "*" : [],
                              },
                            });
                          }}
                          size="small"
                        />
                        <Typography variant="body2" fontWeight={600}>전체 (모든 질병)</Typography>
                      </Box>
                      {extra?.params?.diseases !== "*" && (
                        <FormControl fullWidth>
                          <Select
                            multiple
                            value={Array.isArray(extra?.params?.diseases) ? extra.params.diseases : []}
                            onChange={(e) => {
                              setExtra({
                                ...extra,
                                params: {
                                  ...extra?.params,
                                  diseases: e.target.value,
                                },
                              });
                            }}
                            renderValue={(selected) => {
                              if (selected.length === 0) return "질병을 선택하세요";
                              return DiseaseList
                                .filter((d) => selected.includes(d.id))
                                .map((d) => d.text)
                                .join(", ");
                            }}
                            size="small"
                            sx={{ height: 41 }}
                            MenuProps={{ PaperProps: { sx: { maxHeight: 300 } } }}
                          >
                            {DiseaseList.map((disease) => (
                              <MenuItem key={disease.id} value={disease.id}>
                                <Checkbox checked={Array.isArray(extra?.params?.diseases) && extra.params.diseases.includes(disease.id)} size="small" />
                                <Typography variant="body2">{disease.text}</Typography>
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}
                    </Box>
                  </Grid>
                  <Grid container sx={{ mb: 3 }}>
                    <Box sx={{ mb: 2, width: "100%" }}>
                      <DefaultLabel name="버튼 텍스트" />
                      <OutlinedInputDefault
                        value={extra?.btn_text || ""}
                        onChange={(e) =>
                          setExtra({ ...extra, btn_text: e.target.value })
                        }
                        name="btn_text"
                      />
                    </Box>
                  </Grid>
                </>
              ) : (
                <>
                  <Grid>
                    <Box sx={{ mb: 2, width: "100%" }}>
                      {/* <DefaultLabel name="이미지" /> */}
                      <Grid
                        container
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Grid>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            <IconButton
                              aria-label="prev"
                              disabled={index + 1 <= 1 ? true : false}
                              onClick={() => handleBannerTargetChange("prev")}
                            >
                              <ArrowBackIosIcon />
                            </IconButton>
                            <IconButton
                              aria-label="next"
                              disabled={
                                banner.length <= index + 1 ? true : false
                              }
                              onClick={() => handleBannerTargetChange("next")}
                            >
                              <ArrowForwardIosIcon />
                            </IconButton>
                          </Stack>
                        </Grid>
                        <Grid>
                          <GreyLightButton
                            sx={{ mr: 1, height: 36 }}
                            onClick={handleBannerAdd}
                          >
                            추가
                          </GreyLightButton>
                          <GreyLightButton
                            sx={{ mr: 1, height: 36 }}
                            onClick={handleDelete}
                          >
                            삭제
                          </GreyLightButton>
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Grid sx={{ flexGrow: 1 }}>
                          <ImgFileInput
                            accept="image/*"
                            id="contained-button-file"
                            multiple
                            type="file"
                            ref={inputRef}
                            onChange={handleAddImage}
                          />
                          {banner[index] && banner[index].img_url ? (
                            <Grid
                              container
                              justifyContent="center"
                              alignItems="center"
                              // onMouseEnter={() => setIsShown(true)}
                              // onMouseLeave={() => setIsShown(false)}
                              sx={{
                                height: 127,
                                mt: 2,
                                mb: 2,
                                backgroundColor: "#bebebe",
                                border: "1px solid #c4c4c4",
                                backgroundImage: `url(${banner[index].img_url})`,
                                backgroundSize: "cover",
                                backgroundPosition: "50% 50%",
                                backgroundRepeat: "no-repeat",
                              }}
                            ></Grid>
                          ) : (
                            <Grid
                              container
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                height: 127,
                                mt: 2,
                                mb: 2,
                                backgroundColor: "#F6F6F8",
                                borderRadius: "5px",
                              }}
                            >
                              <label htmlFor="contained-button-file">
                                <Box sx={{ cursor: "pointer" }}>
                                  <Grid sx={{ color: "white" }}>
                                    <img
                                      src={images.inc_img_plus.default}
                                      alt="img_plus"
                                    />
                                  </Grid>
                                  <Typography
                                    variant="body2"
                                    fontWeight={500}
                                    color="#DDDDDF"
                                  >
                                    이미지 추가
                                  </Typography>
                                </Box>
                              </label>
                            </Grid>
                          )}
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                  <Grid container sx={{ mb: 3 }}>
                    <Box sx={{ mb: 2, width: "100%" }}>
                      <DefaultLabel name="이미지명" />
                      <OutlinedInputRightAdornment
                        value={banner[index].img_name}
                        onChange={(e) => {
                          if (e.target.value.length > 100) {
                          } else {
                            handleTextUpdate(e, "name");
                          }
                        }}
                        name="banner_name"
                        adorment={` ${
                          banner[index].img_name
                            ? banner[index].img_name.length
                            : 0
                        }/ 100자`}
                      />
                    </Box>
                  </Grid>
                </>
              )}
              {adGoods?.value == 6 ? null : adGoods?.value == 7 ? (
                <Grid container sx={{ mb: 3 }}>
                  <Box sx={{ mb: 2, width: "100%" }}>
                    <DefaultLabel name="혜택탭 URL" />
                    <OutlinedInputRightAdornment
                      value={banner[index].link_url}
                      onChange={(e) => handleTextUpdate(e, "android")}
                      name={"Android"}
                      adorment={"Android"}
                      krName={"Android"}
                    />
                    <Grid sx={{ mt: 0.625, mb: 1.25 }}></Grid>
                    <OutlinedInputRightAdornment
                      value={banner[index].link_url_i}
                      onChange={(e) => handleTextUpdate(e, "ios")}
                      name={"IOS"}
                      adorment={"IOS"}
                      krName={"IOS"}
                    />
                  </Box>
                  <Box sx={{ mb: 2, width: "100%" }}>
                    <Grid
                      container
                      justifyContent="space-between"
                      sx={{ width: "100%" }}
                    >
                      <DefaultLabel name={"열관리탭 url"} />
                      <Box style={{ display: "flex", flexDirection: "row" }}>
                        <DefaultLabel name={"활성"} />
                        <Checkbox
                          checked={!extra?.position?.fever_tab?.disabled}
                          onChange={(e) => setExtra({
                            ...(extra || {}),
                            position: {
                              ...(extra?.position || {}),
                              fever_tab: {
                                ...(extra?.position?.fever_tab || {}),
                                disabled: !e.target.checked,
                              },
                            },
                          })}
                          sx={{
                            p: 0,
                            "& .MuiSvgIcon-root": { fontSize: 22 },
                          }}
                        />
                      </Box>
                    </Grid>
                    <OutlinedInputRightAdornment
                      value={extra?.position?.fever_tab?.url || ""}
                      onChange={(e) => setExtra({
                        ...(extra || {}),
                        position: {
                          ...(extra?.position || {}),
                          fever_tab: {
                            ...(extra?.position?.fever_tab || {}),
                            url: e.target.value,
                          },
                        },
                      })}
                      name={"Android"}
                      adorment={"Android"}
                      krName={"Android"}
                    />
                    <Grid sx={{ mt: 0.625, mb: 1.25 }}></Grid>
                    <OutlinedInputRightAdornment
                      value={extra?.position?.fever_tab?.url_i || ""}
                      onChange={(e) => setExtra({
                        ...(extra || {}),
                        position: {
                          ...(extra?.position || {}),
                          fever_tab: {
                            ...(extra?.position?.fever_tab || {}),
                            url_i: e.target.value,
                          },
                        },
                      })}
                      name={"IOS"}
                      adorment={"IOS"}
                      krName={"IOS"}
                    />
                  </Box>
                </Grid>
              ) : adGoods?.value == 8 ? (
                <UrlInputByOpenType
                  key={`url-input-${index}-${banner[index].open_type}`}
                  openType={banner[index].open_type}
                  linkUrl={banner[index].link_url}
                  linkUrlI={banner[index].link_url_i}
                  onOpenTypeChange={() => {}}
                  onUrlChange={(url, urlI) => {
                    const bannerNew = banner.map((data, i) => {
                      if (index === i) {
                        data.link_url = url;
                        data.link_url_i = urlI;
                      }
                      return data;
                    });
                    setBanner(bannerNew);
                  }}
                />
              ) : (
                <UrlInputByOpenType
                  key={`url-input-${index}-${banner[index].open_type}`}
                  openType={banner[index].open_type}
                  openTypeList={OpenType[String(adGoods.value)]}
                  linkUrl={banner[index].link_url}
                  linkUrlI={banner[index].link_url_i}
                  onOpenTypeChange={(newType) => {
                    const bannerNew = banner.map((data, i) => {
                      if (index === i) {
                        data.open_type = newType;
                        data.link_url = "";
                        data.link_url_i = "";
                      }
                      return data;
                    });
                    setBanner(bannerNew);
                  }}
                  onUrlChange={(url, urlI) => {
                    const bannerNew = banner.map((data, i) => {
                      if (index === i) {
                        data.link_url = url;
                        data.link_url_i = urlI;
                      }
                      return data;
                    });
                    setBanner(bannerNew);
                  }}
                />
              )}
              {adGoods?.value == 4 ||
              adGoods?.value == 5 ||
              adGoods?.value == 7 || adGoods.value == 8 || adGoods.value == 13 || adGoods.value == 14 || adGoods.value == 15 ? (
                <Box sx={{ mt: 2 }} />
              ) : (
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  sx={{ mb: 7 }}
                >
                  {banner.map((data, i) => {
                    return (
                      <img
                        key={i}
                        onClick={() => handlepageGo(i)}
                        src={
                          index === i
                            ? images.inc_circle_on.default
                            : images.inc_circle_off.default
                        }
                        alt="right_arrow"
                        style={{ marginRight: 8, cursor: "pointer" }}
                      />
                    );
                  })}
                </Grid>
              )}
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                sx={{ mb: 8.75 }}
              >
                <Button
                  variant="contained"
                  fullWidth
                  onClick={handleComplete}
                  sx={{
                    height: 56,
                    boxShadow: 0,
                    "&:hover": {
                      boxShadow: 0,
                    },
                  }}
                >
                  <Typography variant="h3" fontWeight={500}>
                    등록
                  </Typography>
                </Button>
              </Grid>
            </Grid>
          </DefaultItem>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CompAdAdd;
